import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['submitter'];

  disable_submitter(event) {
    this.submitterTarget.setAttribute('disabled', true);

    Siepomaga.timeout(this.submitterTarget.dataset.disableTime * 1000, () => {
      this.submitterTarget.removeAttribute('disabled');
    });
  }
}
